export function SubmitEdited() {
    return (<div id={'submit trans edited'} className={'hidden'}>

    </div>)
}